import { Component, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { InputFieldComponent } from '../../forms/input-field/input-field.component';
import { MatTooltip } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';
import { MatListItem } from '@angular/material/list';

@Component({
    selector: 'unite-list-item-input',
    templateUrl: './list-item-input.component.html',
    styleUrls: ['./list-item-input.component.scss'],
    imports: [MatListItem, NgClass, MatTooltip, InputFieldComponent]
})
export class ListItemInputComponent {
  classItem = input('');
  control = input<FormControl>();
  editIcon = input(false);
  label = input<string>();
  max = input<number>(null);
  negative = input<boolean>(false);
  required = input(false);
  requiredNotNull = input(false);
  suffix = input<string>();
  tooltip = input<string>();
  type = input<string>();
  pattern = input<string>();

  checkRequired(): boolean {
    if (this.required() !== false && (this.control().value == null || this.control().value === '' || this.control().value === 0)) {
      return true;
    } else if (this.requiredNotNull() !== false && this.control().value == null) {
      return true;
    } else {
      return false;
    }
  }

  checkValid(): boolean {
    return this.control() && this.control().touched && this.control().invalid;
  }
}
